import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Stepper, StepItem, Step, StepPanels, StepPanel, StepList } from 'primeng/stepper';
import { Select } from 'primeng/select';
import { DatePicker } from 'primeng/datepicker';
import { ButtonModule } from 'primeng/button';
import { Textarea } from 'primeng/textarea';
import { DynamicDialogModule, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { PassengerSelectionComponent } from '../../../_components/passenger-selection/passenger-selection.component';
import { TableCardComponent } from '../table-card/table-card.component';
import { Passenger } from '../../../_models/Passenger';
import { Table } from '../../../_models/Table';
import { Restaurant } from '../../../_models/Restaurant';
import { RestaurantSlotTableWithInfo } from '../../../_models/RestaurantSlot';
import {
  PassengerReservation,
  Reservation,
} from '../../../_models/Reservation';
import { ApiService } from '../../../_services';
import { SpinnerService } from '../../../_components/spinner/spinner.service';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-new-booking',
  templateUrl: './new-booking.component.html',
  styleUrl: './new-booking.component.scss',
  standalone: true,
  imports: [Stepper, Step, StepPanels, StepPanel, StepList, Select, DatePicker, ButtonModule, Textarea, PassengerSelectionComponent, TableCardComponent, FormsModule, TranslateModule, DynamicDialogModule],
})
export class NewBookingComponent {
  passenger: Passenger | undefined;
  public restaurants: Restaurant[] = [];
  public passengerList: Passenger[] = [];
  public tableList: Table[] = [];
  public selectedDate: Date | undefined;
  public selectedRestaurant: Restaurant | undefined;
  public notes: string | undefined;
  selectedPassengers: Passenger[] = [];
  public selectedTable: RestaurantSlotTableWithInfo | undefined;
  reservedTableId: number | undefined;
  edit: boolean = false;
  reservation: PassengerReservation | undefined;
  public minDate: Date = new Date();
  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private apiService: ApiService,
    private spinner: SpinnerService
  ) {
    // this.passengerList = this.config.data.companions;
    this.passenger = this.config.data.passenger;
    this.restaurants = this.config.data.restaurants.filter(
      (r: Restaurant) => r.fk_ship == this.passenger?.fk_ship
    );
    if (this.config.data.reservation) {
      this.edit = true;
      this.reservation = this.config.data.reservation;
      this.selectedDate = new Date(this.reservation?.slot_start!);
      this.selectedRestaurant = this.restaurants.find(
        (r) => r.id_restaurant === this.reservation!.id_restaurant
      );
      this.selectedPassengers = this.config.data.selectedPassengers;
      this.reservedTableId = Number(this.reservation!.fk_restaurant_slot_table);
      this.notes = this.reservation?.notes;
    }
  }

  createReservation() {
    this.spinner.show();
    const payload: Reservation = {
      id_impersonated_passenger: this.passenger?.id_passenger!,
      id_restaurant: this.selectedRestaurant!.id_restaurant,
      id_restaurant_slot_table: this.selectedTable!.id_restaurant_slot_table,
      uuid_passengers: this.selectedPassengers.map((p) => p.uuid_passenger),
      notes: this.notes,
    };
    this.apiService.CreateReservation(payload).subscribe({
      next: (data) => {
        this.spinner.hide();
        this.ref.close(data);
      },
      error: (error) => {
        this.spinner.hide();
        console.error(error);
      },
    });
  }

  updateReservation() {
    this.spinner.show();
    const payload: Reservation = {
      id_impersonated_passenger: this.passenger?.id_passenger!,
      id_restaurant: this.selectedRestaurant!.id_restaurant,
      id_restaurant_slot_table: this.selectedTable!.id_restaurant_slot_table,
      uuid_passengers: this.selectedPassengers.map((p) => p.uuid_passenger),
      notes: this.notes,
    };
    this.apiService
      .UpdateReservation(this.reservation?.id_reservation!, payload)
      .subscribe({
        next: (data) => {
          this.spinner.hide();
          this.ref.close(data);
        },
        error: (error) => {
          this.spinner.hide();
          console.error(error);
        },
      });
  }

  stepChange(event: number | undefined) {
    if (event == 2) {
      this.spinner.show();
      this.apiService
        .PassengerCompanions(
          this.passenger?.uuid_passenger!,
          DateTime.fromJSDate(this.selectedDate!).toSQLDate()!
        )
        .subscribe({
          next: (data) => {
            this.passengerList = data;
            this.spinner.hide();
          },
          error: (error) => {
            console.error(error);
            this.spinner.hide();
          },
        });
    }
  }
}
